import styled from 'styled-components'
import {Flexbox} from 'src/components/flexbox/Flexbox'

export const OfferingsContainer = styled.div`
    margin-top: 16px;
`

export const StyledOfferingCard = styled(Flexbox)`
    border-radius: 8px;
    border: 1px solid ${({theme}) => theme.palette.neutral[300]};
    padding: 16px;
    width: 100%;
    margin-bottom: 16px;
`

export const StyledOfferingImage = styled.img`
    width: 44px;
    height: 44px;
    border-radius: 4px;
    object-fit: cover;
`

export const StyledOfferingTitle = styled.h3`
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    color: ${({theme}) => theme.palette.neutral[900]};
`

export const StyledOfferingDescription = styled.p`
    margin: 4px 0 0;
    font-size: 14px;
    color: ${({theme}) => theme.palette.neutral[600]};
` 